import withConnect from "./withConnect";
import { App } from "./App";

const AppConnected = withConnect(App);

export default () => <AppConnected />;
